import htmx from "htmx.org";
import { EditTest, IEditTarget } from "../global";
import { findParagraph } from "../office/Edit";

async function runEditTest(test: EditTest) {
  try {
    const element = document.querySelector(test.selector);
    if (element == null) {
      console.error(`element not found for edit test: ${test.selector}`);
      throw Error();
    }
    const edit = JSON.parse(element.textContent) as IEditTarget;

    const ms = await Word.run(async (context) => {
      const r = await findParagraph(context, edit);
      return r.ms;
    });
    await htmx.ajax("post", test.successUrl, { values: { ms } });
  } catch {
    await htmx.ajax("post", test.failedUrl, {});
  }
}

document.addEventListener(
  "request-edit-test",
  async (e: CustomEvent<EditTest>) => {
    await runEditTest(e.detail);
  }
);
